import { type FormInput, useNavigationConfirmationFormMethods } from '@cosuno/react-router';
import type React from 'react';
import { useId, useLayoutEffect } from 'react';

interface DataLossPreventerProps {
  formInput?: FormInput | false;
  isDirty: boolean;
}

export function useDataLossPreventer({ formInput, isDirty }: DataLossPreventerProps) {
  const { markFormAsClean, markFormAsDirty } = useNavigationConfirmationFormMethods();
  const id = useId();

  // We have to fire this early to mark the form as clean before anything else
  // happens. Otherwise, we may end up with an unwanted confirmation modal
  useLayoutEffect(() => {
    if (!formInput) {
      return undefined;
    }

    if (isDirty) {
      markFormAsDirty(id, formInput);
    } else {
      markFormAsClean(id);
    }

    return () => markFormAsClean(id);
  }, [formInput, markFormAsDirty, markFormAsClean, isDirty, id]);
}

export const DataLossPreventer: React.FC<DataLossPreventerProps> = (props) => {
  useDataLossPreventer(props);

  return null;
};
